const FEATURES = {
  ORDERS: "FEATURE_ORDERS",
  PLANNING: "FEATURE_PLANNING",
  TRIPS: "FEATURE_TRIPS",
  POD: "FEATURE_POD",
  FINANCE: "FEATURE_FINANCE",
  OFFICE: "FEATURE_OFFICE",
  FLEET: "FEATURE_FLEET",
  WORKSHOP: "FEATURE_WORKSHOP",
  INSIGHTS: "FEATURE_INSIGHTS",
  ADMIN: "FEATURE_ADMIN",
};

const FEATURE_LABELS = {
  [FEATURES.ORDERS]: "Order to trip",
  [FEATURES.PLANNING]: "Planning & dispatch",
  [FEATURES.TRIPS]: "Trip execution",
  [FEATURES.POD]: "POD & documents",
  [FEATURES.FINANCE]: "Finance & billing",
  [FEATURES.OFFICE]: "Office operations",
  [FEATURES.FLEET]: "Driver & fleet",
  [FEATURES.WORKSHOP]: "Workshop",
  [FEATURES.INSIGHTS]: "Insights & reports",
  [FEATURES.ADMIN]: "Administration",
};

/** Legacy phase toggles on system customers → ERP feature codes */
const PHASE_TO_FEATURES = {
  phase1: [
    FEATURES.ORDERS,
    FEATURES.PLANNING,
    FEATURES.TRIPS,
    FEATURES.POD,
  ],
  phase2: [FEATURES.FINANCE],
  phase3: [FEATURES.FLEET],
  phase4: [FEATURES.WORKSHOP],
  phase5: [FEATURES.OFFICE, FEATURES.INSIGHTS],
};

const FEATURE_TO_PHASE = Object.fromEntries(
  Object.entries(PHASE_TO_FEATURES).flatMap(([phase, feats]) =>
    feats.map((f) => [f, phase]),
  ),
);

function featuresFromModuleToggles(modules = {}) {
  const out = new Set([FEATURES.ADMIN]);
  for (const [phase, enabled] of Object.entries(modules)) {
    if (!enabled) continue;
    for (const f of PHASE_TO_FEATURES[phase] ?? []) out.add(f);
  }
  return [...out];
}

function isFeatureEnabled(modules, feature) {
  if (feature === FEATURES.ADMIN) return true;
  const phase = FEATURE_TO_PHASE[feature];
  if (!phase) return false;
  return Boolean(modules?.[phase]);
}

export {
  FEATURE_LABELS,
  FEATURE_TO_PHASE,
  FEATURES,
  PHASE_TO_FEATURES,
  featuresFromModuleToggles,
  isFeatureEnabled,
};
